import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { css, styled } from 'styled-components';
import { Box } from "../../../box/src";
import { Button } from "../../../button/src";
import { FontAwesomeIcon } from "../../../font-awesome-icon/src";
import { focusOutline } from "../../../theme/src";
export const DropdownItem = ({ isFocused = false, isOpen = false, item, onClickItem, onCloseDropdown, onFocusItem, }) => {
    const handleClose = useCallback(() => {
        onCloseDropdown('DropdownItem');
    }, [onCloseDropdown]);
    let navigate;
    try {
        navigate = useNavigate();
    }
    catch (_a) {
        navigate = (href) => (window.location.href = href);
    }
    const handleClick = useCallback((event) => {
        if (item === null || item === void 0 ? void 0 : item.href) {
            navigate(item.href);
        }
        else if (item.onClick) {
            event.stopPropagation();
            item.onClick(item);
        }
        else if (onClickItem) {
            event.stopPropagation();
            onClickItem(item);
        }
        handleClose();
    }, [handleClose, item, navigate, onClickItem]);
    const handleFocusItem = useCallback(() => onFocusItem(item), [item, onFocusItem]);
    const testId = item.dataTestId || item.label;
    return (_jsx(WrapperItem, { "$isFocused": isOpen && isFocused, "data-testid": testId, onFocus: handleFocusItem, onMouseEnter: handleFocusItem, children: _jsx(Button, { "aria-label": item.ariaLabel, dataTestId: `${testId}-button`, icon: item.icon, onClick: handleClick, variant: "dropdown", children: _jsxs(EllipsisBox, { "$isFocused": isFocused, children: [_jsx("span", { children: item.label }), (item === null || item === void 0 ? void 0 : item.selected) && (_jsx(Box, { dataTestId: "check-icon", pl: 3, children: _jsx(FontAwesomeIcon, { height: "16px", iconName: "check" }) }))] }) }) }));
};
const WrapperItem = styled(Box).attrs(({ $isFocused, theme }) => ({
    alignItems: 'center',
    bg: $isFocused ? theme.colors.primary : undefined,
    color: $isFocused ? theme.colors.white : theme.input.color,
    px: 3,
    width: '100%',
})) `
  ${focusOutline};
  cursor: pointer;
  overflow: hidden;
  user-select: none;

  ${({ $isFocused, theme }) => css `
    svg {
      color: ${$isFocused ? theme.colors.white : theme.input.color} !important;
    }
  `}
`;
const EllipsisBox = styled(Box).attrs(({ $isFocused, theme }) => ({
    color: $isFocused ? theme.colors.white : theme.input.color,
    display: 'flex',
    maxWidth: { _: 226, xl: 'max-content' },
})) `
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
//# sourceMappingURL=DropdownItem.js.map